module.exports = __webpack_public_path__ + "img/About_Desktop_05.b60790bc.jpg";